import { Record } from 'immutable'

export const SET_COMPANY_EMPLOYEE = 'SET_COMPANY_EMPLOYEE'

export const ROLE = {
  MEMBER: 1,
  ADMIN: 2,
}

export const STATUS = {
  UNVERIFIED: 0,
  PENDING: 1,
  VERIFIED: 2,
  INVITED: 3,
}

/**
 * Reducer section
 */
const initialState = {}

const CompanyEmployee = new Record(initialState)

// FlowType
type Action = {
  type: string,
  payload: {
    company: Company,
  },
}

// FlowType
type Action = {
  type: string,
  payload: {},
}

export function reducer(state: Record = initialState, action: Action) {
  switch (action.type) {
    case SET_COMPANY_EMPLOYEE:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export function setCompanyEmployee(payload: CompanyEmployee) {
  return {
    type: SET_COMPANY_EMPLOYEE,
    payload,
  }
}
